import React from 'react';

// `phones` es el pool ya scopeado por el backend (sender-numbers): cada item
// trae phone_id, phone_number, name y owned. Se selecciona por phone_id.
const PhoneSelector = ({ phones, selectedPhoneId, onPhoneChange }) => {
  if (!phones || phones.length === 0) {
    return null;
  }

  return (
    <div className='flex items-center gap-2'>
      <label htmlFor='phone-selector' className='text-xs text-slate-500'>
        Teléfono:
      </label>
      <select
        id='phone-selector'
        value={selectedPhoneId}
        onChange={e => onPhoneChange(e.target.value)}
        className='bg-white text-gray-800 text-sm rounded-lg px-2 pr-7 py-1 focus:outline-none focus:ring-1 focus:ring-white min-w-32'
      >
        {phones.map(phone => (
          <option key={phone.phone_id} value={phone.phone_id}>
            {phone.owned ? '★ ' : ''}{phone.name} - {phone.phone_number}{phone.owned ? ' (empresa)' : ''}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PhoneSelector;
